export default __webpack_public_path__ + "3fec233eafa756966cfe8330b1a58d31.png";